// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + {"102":"xlsx","133":"pdfmake","182":"canvg"}[chunkId] + "." + {"102":"147aa65d","133":"e7185bf7","182":"63a45769"}[chunkId] + ".chunk.js";
};